var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"py-4 bg-light mt-auto"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between small"},[_c('strong',[_vm._v("Copyright © 2020 "),_c('a',{attrs:{"href":"#"}},[_vm._v("Bacolod Triumph Hardware")]),_vm._v(".")]),_vm._v(" All rights reserved.\n        ")])])])
}]

export { render, staticRenderFns }